import React, { useEffect, lazy } from 'react';
import { useRoutes, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { AzureSSOProvider, useAzureSSO } from '../AzureSSOProvider';


import MainLayout from "layout/MainLayout";
import Loadable from "ui-component/Loadable";

const AboutEngineLite = Loadable(
  lazy(() => import("views/about/AboutEngineLite"))
);
const AboutOptimizer = Loadable(
  lazy(() => import("views/about/AboutOptimizer"))
);
const AboutSimulator = Loadable(
  lazy(() => import("views/about/AboutSimulator"))
);
const Admin = Loadable(lazy(() => import("views/Admin")));
const Scenarios = Loadable(lazy(() => import("views/Scenarios")));

const HashHandler = Loadable(lazy(() => import("views/HashHandler")));
const Optimizer = Loadable(lazy(() => import("views/optimizer/Optimizer")));
const Simulator = Loadable(lazy(() => import("views/simulator/Simulator")));

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, login, acquireTokenSilent, isTokenReady } = useAzureSSO();


  // Check if the token exists
  useEffect(() => {
    if (!isAuthenticated) {
      login();
    } else {
      acquireTokenSilent()
    }
  }, [isAuthenticated, login]);

  if (!isTokenReady) {
    return <div>Loading...</div>;
  }
  return isAuthenticated ? children : <div>Redirecting...</div>;
};


export default function ThemeRoutes() {
  // const user = useSelector((state) => state.user);
  return useRoutes([
    {
      path: "/",
      element: <ProtectedRoute> <MainLayout /></ProtectedRoute>,
      children: [

        {
          path: "/",
          element: <ProtectedRoute> <AboutEngineLite /></ProtectedRoute>,
        },

        {
          path: "/about_englinelite",
          element: <ProtectedRoute><AboutEngineLite /></ProtectedRoute>,
        },
        {
          path: "/about_optimizer",
          element: <ProtectedRoute><AboutOptimizer /></ProtectedRoute>,
        },
        {
          path: "/about_simulator",
          element: <ProtectedRoute><AboutSimulator /></ProtectedRoute>,
        },
        {
          path: "/admin",
          element: <ProtectedRoute><Admin /></ProtectedRoute>,
        },
        {
          path: "/markets",
          element: <ProtectedRoute><Scenarios /></ProtectedRoute>,
        },
        {
          path: "/hash/:hash",
          element: <ProtectedRoute><HashHandler /></ProtectedRoute>,
        },
        {
          path: "/optimizer",
          element: <ProtectedRoute><Optimizer /></ProtectedRoute>,
        },
        {
          path: "/simulator",
          element: <ProtectedRoute><Simulator /></ProtectedRoute>,
        },
      ],
    },
  ]);
}
